/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/upgrade_invasion': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/><circle pid="1" cx="16" cy="9.684" r="1.263"/><circle pid="2" cx="16" cy="15.579" r="1.263"/><circle pid="3" cx="9.263" cy="15.579" r="1.263"/><circle pid="4" cx="13.895" cy="13.474" r="1.263"/><circle pid="5" cx="13.895" cy="17.684" r="1.263"/><circle pid="6" cx="18.105" cy="17.684" r="1.263"/><circle pid="7" cx="22.736" cy="15.579" r="1.263"/><circle pid="8" cx="18.105" cy="13.474" r="1.263"/><circle pid="9" cx="16" cy="22.316" r="1.263"/>'
  }
})
